/* Divine Hindu — "Divine Picks, Best Prices" (sections/dh-divine-picks.liquid), Oct 2026.
   One-tap ADD to cart, − / + steppers, an option chooser for items with sizes or packs, price tabs and desktop arrows.
   Cart work goes through Shopify's AJAX cart; the theme's drawer (window.DivineCart) is refreshed afterwards so the
   header count, cart rules and checkout stay exactly as the theme runs them. Nothing here touches checkout. */
(function () {
  if (window.__dpxReady) return;
  window.__dpxReady = true;

  var state = { byV: {}, byP: {}, keyByV: {}, known: false };
  /* quantities asked for but not yet confirmed (fast repeated taps build on these, not on the last cart) */
  var want = {}, pend = {};
  function track(vid, qty) { want[vid] = qty; pend[vid] = (pend[vid] || 0) + 1; }
  function untrack(vid) { pend[vid] = (pend[vid] || 1) - 1; if (pend[vid] <= 0) { delete pend[vid]; delete want[vid]; } }
  var chain = Promise.resolve();
  var sheet = null, toast = null, toastTimer = null, lastFocus = null;

  function qa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function txt(root, key, fallback) {
    var sec = root && root.closest ? root.closest('[data-dpx]') : null;
    sec = sec || document.querySelector('[data-dpx]');
    return (sec && sec.getAttribute('data-t-' + key)) || fallback;
  }
  function queue(fn) { var p = chain.then(fn, fn); chain = p.catch(function () {}); return p; }
  function json(r) { return r.ok ? r.json() : r.json().then(function (e) { throw e; }, function () { throw {}; }); }

  /* ---------- cart state ---------- */
  function applyCart(cart) {
    if (!cart || !cart.items) return;
    var byV = {}, byP = {}, keyByV = {};
    cart.items.forEach(function (it) {
      byV[it.variant_id] = (byV[it.variant_id] || 0) + it.quantity;
      byP[it.product_id] = (byP[it.product_id] || 0) + it.quantity;
      if (!keyByV[it.variant_id]) keyByV[it.variant_id] = it.key;
    });
    state = { byV: byV, byP: byP, keyByV: keyByV, known: true };
    if (!window.DivineCart) qa('[data-cart-count], .header-cart-count').forEach(function (el) { el.textContent = cart.item_count; });
    paintAll();
  }
  function paintRow(row) {
    if (row.classList.contains('is-busy')) return;
    var multi = row.hasAttribute('data-multi');
    var vid = row.getAttribute('data-vid');
    var n = multi ? (state.byP[row.getAttribute('data-pid')] || 0) : (vid in want ? want[vid] : (state.byV[vid] || 0));
    setRow(row, n);
  }
  function setRow(row, n) {
    var add = row.querySelector('[data-dpx-add]'), step = row.querySelector('.dpx-step');
    if (!add || !step) return;
    var q = step.querySelector('[data-dpx-qty]');
    if (n > 0) { add.hidden = true; step.hidden = false; if (q) q.textContent = n; }
    else { add.hidden = false; step.hidden = true; }
  }
  function paintAll() {
    qa('[data-dpx] .dpx-row').forEach(paintRow);
    if (sheet && sheet.classList.contains('is-open')) qa('.dpx-row', sheet).forEach(paintRow);
  }
  function loadCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(json).then(function (c) { applyCart(c); return c; });
  }
  /* Hand the updated cart to the drawer (assets/cart-drawer.js), which redraws itself and the header
     count and tells every row here through 'dh:cart'. Without a cart it reads /cart.js once. */
  function syncDrawer(cart) {
    if (cart) applyCart(cart);
    var dc = window.DivineCart;
    if (dc && cart && typeof dc.apply === 'function') {
      try { dc.apply(cart); } catch (e) {}
    } else if (dc && typeof dc.refresh === 'function') {
      try { dc.refresh(); } catch (e) {}
    } else if (!cart) {
      loadCart().catch(function () {});
    }
  }

  /* ---------- speed (Oct 2026) ----------
     A tap shows its result at once: the − n + stepper, the header count and "Added to cart" appear
     before Shopify answers, and are put back if Shopify refuses the item (sold out, limit).
     Each add is ONE request: Shopify sends the updated cart back with it (section "dh-cart-json",
     sections/dh-cart-json.liquid), so no separate /cart.js is needed afterwards. */
  var CART_SECTION = 'dh-cart-json';
  function cartFrom(res) {
    if (window.DivineCart && typeof window.DivineCart.cartFrom === 'function') return window.DivineCart.cartFrom(res);
    try {
      var html = res && res.sections && res.sections[CART_SECTION];
      if (!html) return null;
      var c = JSON.parse(html.slice(html.indexOf('>', html.indexOf('data-dh-cart')) + 1, html.lastIndexOf('</script>')));
      return c && c.items && typeof c.item_count !== 'undefined' ? c : null;
    } catch (e) { return null; }
  }
  function countBy(n) {
    if (!n) return;
    var dc = window.DivineCart;
    if (dc && typeof dc.pending === 'function') { dc.pending(n); return; }
    qa('[data-cart-count], .header-cart-count').forEach(function (el) { el.textContent = Math.max(0, (parseInt(el.textContent, 10) || 0) + n); });
  }
  function countDone(n, ok) {
    if (!n) return;
    var dc = window.DivineCart;
    if (dc && typeof dc.settle === 'function') { dc.settle(n); if (!ok) dc.pending(0); return; }
    if (!ok) countBy(-n);
  }
  window.DHPicks = { paint: function (root) { if (state.known) qa('.dpx-row', root || document).forEach(paintRow); } };
  document.addEventListener('dh:cart', function (e) { if (e && e.detail) applyCart(e.detail); });

  /* ---------- cart actions ---------- */
  function addVariant(vid, row, have) {
    var before = typeof have === 'number' ? have : (vid in want ? want[vid] : (state.byV[vid] || 0));
    track(vid, before + 1);
    if (row) { row.classList.add('is-busy'); setRow(row, (row.hasAttribute('data-multi') ? (state.byP[row.getAttribute('data-pid')] || 0) : before) + 1); }
    countBy(1);
    showToast(txt(row, 'added', 'Added to cart'), false);
    return queue(function () {
      return fetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1 }], sections: CART_SECTION })
      }).then(json);
    }).then(function (res) {
      untrack(vid);
      countDone(1, true);
      if (row) row.classList.remove('is-busy');
      syncDrawer(cartFrom(res));
    }, function (err) {
      untrack(vid);
      countDone(1, false);
      if (row) { row.classList.remove('is-busy'); }
      paintAll();
      syncDrawer(null);
      showToast((err && err.description) || txt(row, 'error', 'Could not add this item. Please try again.'), true);
    });
  }
  function changeVariant(vid, qty, row, have) {
    var key = state.keyByV[vid];
    var delta = qty - (typeof have === 'number' ? have : (state.byV[vid] || 0));
    track(vid, qty);
    if (row) { row.classList.add('is-busy'); setRow(row, qty); }
    countBy(delta);
    return queue(function () {
      return fetch('/cart/change.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key || String(vid), quantity: qty })
      }).then(json);
    }).then(function (cart) {
      untrack(vid);
      countDone(delta, true);
      if (row) row.classList.remove('is-busy');
      syncDrawer(cart && cart.items ? cart : null);
    }, function (err) {
      untrack(vid);
      countDone(delta, false);
      if (row) row.classList.remove('is-busy');
      paintAll();
      syncDrawer(null);
      showToast((err && err.description) || txt(row, 'error', 'Could not update the cart. Please try again.'), true);
    });
  }

  /* ---------- toast ---------- */
  function showToast(message, isError) {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'dpx-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      toast.innerHTML = '<span class="dpx-toast__t"></span><button type="button" class="dpx-toast__btn"></button>';
      toast.querySelector('.dpx-toast__btn').addEventListener('click', function () {
        hideToast();
        if (window.DivineCart && typeof window.DivineCart.open === 'function') window.DivineCart.open();
        else window.location.href = '/cart';
      });
      document.body.appendChild(toast);
    }
    toast.querySelector('.dpx-toast__t').textContent = message;
    var btn = toast.querySelector('.dpx-toast__btn');
    btn.textContent = txt(null, 'view', 'View cart');
    btn.hidden = !!isError;
    toast.classList.toggle('is-err', !!isError);
    toast.classList.toggle('dpx-toast--top', !!(sheet && sheet.classList.contains('is-open')));
    void toast.offsetWidth;
    toast.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(hideToast, isError ? 3600 : 2800);
  }
  function hideToast() { if (toast) toast.classList.remove('is-on'); }

  /* ---------- option chooser ---------- */
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function openSheet(row) {
    var data;
    try { data = JSON.parse(row.querySelector('[data-dpx-json]').textContent); } catch (e) { data = null; }
    if (!data || !data.variants) { var a = row.querySelector('.dpx-row__title'); if (a) window.location.href = a.href; return; }
    if (!sheet) {
      sheet = document.createElement('div');
      sheet.className = 'dpx-sheet';
      sheet.innerHTML = '<div class="dpx-sheet__bg" data-dpx-close></div><div class="dpx-sheet__panel" role="dialog" aria-modal="true" aria-labelledby="dpx-sheet-ttl"><div class="dpx-sheet__grip"></div><div class="dpx-sheet__top"></div><div class="dpx-sheet__list"></div></div>';
      document.body.appendChild(sheet);
      sheet.addEventListener('click', function (e) {
        if (e.target.closest('[data-dpx-close]')) { closeSheet(); return; }
        rowAction(e);
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && sheet.classList.contains('is-open')) closeSheet(); });
    }
    var title = txt(row, 'sheet', 'Choose an option');
    sheet.querySelector('.dpx-sheet__top').innerHTML =
      (data.img ? '<img src="' + esc(data.img) + '" alt="" width="56" height="56">' : '') +
      '<div class="dpx-sheet__ttl"><small>' + esc(title) + '</small><strong id="dpx-sheet-ttl">' + esc(data.title) + '</strong></div>' +
      '<button type="button" class="dpx-sheet__x" data-dpx-close aria-label="Close">&times;</button>';
    var addLabel = txt(row, 'add', 'ADD');
    sheet.querySelector('.dpx-sheet__list').innerHTML = data.variants.map(function (v) {
      return '<div class="dpx-row" data-vid="' + v.id + '" data-pid="' + esc(row.getAttribute('data-pid')) + '">' +
        '<div class="dpx-row__info"><span class="dpx-row__title">' + esc(v.t) + '</span>' +
        '<div class="dpx-row__price"><b>' + esc(v.p) + '</b>' + (v.c ? '<s>' + esc(v.c) + '</s><em>' + v.o + '% off</em>' : '') + '</div></div>' +
        '<div class="dpx-row__act">' + (v.a
          ? '<button type="button" class="dpx-add" data-dpx-add aria-label="' + esc(addLabel + ': ' + v.t) + '">' + esc(addLabel) + '</button>' +
            '<div class="dpx-step" hidden><button type="button" data-dpx-dec aria-label="One less">&minus;</button><span data-dpx-qty aria-live="polite">0</span><button type="button" data-dpx-inc aria-label="One more">+</button></div>'
          : '<span class="dpx-row__soldout">Sold out</span>') + '</div></div>';
    }).join('');
    lastFocus = document.activeElement;
    hideToast();
    sheet.classList.add('is-open');
    document.documentElement.classList.add('dpx-lock');
    qa('.dpx-row', sheet).forEach(paintRow);
    requestAnimationFrame(function () { sheet.classList.add('is-in'); var x = sheet.querySelector('.dpx-sheet__x'); if (x) x.focus(); });
  }
  function closeSheet() {
    if (!sheet) return;
    sheet.classList.remove('is-in');
    document.documentElement.classList.remove('dpx-lock');
    setTimeout(function () { sheet.classList.remove('is-open'); }, 280);
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
  }

  /* ---------- clicks ---------- */
  function rowAction(e) {
    var btn = e.target.closest('[data-dpx-add], [data-dpx-inc], [data-dpx-dec]');
    if (!btn) return false;
    var row = btn.closest('.dpx-row');
    if (!row) return false;
    e.preventDefault();
    if (row.hasAttribute('data-multi')) { openSheet(row); return true; }
    var vid = row.getAttribute('data-vid');
    var have = vid in want ? want[vid] : (state.byV[vid] || 0);
    if (btn.hasAttribute('data-dpx-dec')) changeVariant(vid, Math.max(0, have - 1), row, have);
    else if (btn.hasAttribute('data-dpx-inc') && have > 0 && (state.keyByV[vid] || vid in want)) changeVariant(vid, have + 1, row, have);
    else addVariant(vid, row, have);
    return true;
  }
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-dpx]')) return;
    if (rowAction(e)) return;
    var tab = e.target.closest('[data-dpx-tab]');
    if (tab) { selectTab(tab, true); return; }
    var nav = e.target.closest('[data-dpx-prev], [data-dpx-next]');
    if (nav) {
      var rail = nav.closest('[data-dpx]').querySelector('[data-dpx-rail]');
      var card = rail && rail.querySelector('.dpx-card');
      var step = card ? card.getBoundingClientRect().width + 18 : rail.clientWidth * 0.8;
      rail.scrollBy({ left: nav.hasAttribute('data-dpx-prev') ? -step : step, behavior: 'smooth' });
    }
  });

  /* ---------- price tabs ---------- */
  function selectTab(tab, focus) {
    var list = tab.closest('[role="tablist"]');
    var card = tab.closest('.dpx-card');
    if (!list || !card) return;
    qa('[data-dpx-tab]', list).forEach(function (t) {
      var on = t === tab;
      t.classList.toggle('is-on', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.setAttribute('tabindex', on ? '0' : '-1');
      var panel = document.getElementById(t.getAttribute('aria-controls'));
      if (panel) panel.hidden = !on;
    });
    var see = card.querySelector('[data-dpx-see]');
    if (see && tab.getAttribute('data-see')) see.setAttribute('href', tab.getAttribute('data-see'));
    if (focus) tab.focus({ preventScroll: true });
  }
  document.addEventListener('keydown', function (e) {
    var tab = e.target.closest && e.target.closest('[data-dpx-tab]');
    if (!tab || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')) return;
    var tabs = qa('[data-dpx-tab]', tab.closest('[role="tablist"]'));
    var i = tabs.indexOf(tab) + (e.key === 'ArrowRight' ? 1 : -1);
    if (i < 0) i = tabs.length - 1; if (i >= tabs.length) i = 0;
    e.preventDefault(); selectTab(tabs[i], true);
  });

  /* ---------- section setup (also when edited in the theme editor) ---------- */
  function initSection(sec) {
    if (!sec || sec.__dpxInit) return;
    sec.__dpxInit = true;
    var rail = sec.querySelector('[data-dpx-rail]');
    var prev = sec.querySelector('[data-dpx-prev]'), next = sec.querySelector('[data-dpx-next]');
    function arrows() {
      if (!rail || !prev || !next) return;
      var max = rail.scrollWidth - rail.clientWidth - 4;
      prev.hidden = rail.scrollLeft <= 4;
      next.hidden = max <= 0 || rail.scrollLeft >= max;
    }
    if (rail) { rail.addEventListener('scroll', arrows, { passive: true }); window.addEventListener('resize', arrows, { passive: true }); arrows(); }
    if (!state.known) {
      var go = function () { if (!state.known) loadCart().catch(function () {}); };
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) { if (es.some(function (x) { return x.isIntersecting; })) { io.disconnect(); go(); } }, { rootMargin: '300px 0px' });
        io.observe(sec);
      } else { go(); }
    } else {
      qa('.dpx-row', sec).forEach(paintRow);
    }
  }
  function initAll() { qa('[data-dpx]').forEach(initSection); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', function (e) { if (e.target && e.target.querySelectorAll) qa('[data-dpx]', e.target).forEach(initSection); });
  document.addEventListener('shopify:block:select', function (e) {
    var card = e.target && e.target.closest && e.target.closest('.dpx-card');
    if (card && card.scrollIntoView) card.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  });
})();
